export const addFieldToSchema = (form, field, layout)=>{
    const newSteps = form.steps?.map((step)=>{
        return {
            ...step,
            layout: {
                ...step.layout,
                large: {
                    ...step.layout?.large,
                    items: step.layout?.large?.items?.map((item)=>{
                        return {
                            ...item,
                            row: layout.row <= item.row ? (item.row || 0) + 1 : item.row
                        };
                    }) || step.layout?.large?.items
                }
            }
        };
    });
    newSteps?.[0].layout?.large?.items?.unshift(layout);
    return {
        ...form,
        fields: [
            field,
            ...form.fields || []
        ],
        steps: newSteps || form.steps
    };
};

//# sourceMappingURL=add-field-to-schema.js.map